import { date } from "../../lib/date";

export default function TableCellDate({value}) {
  return date(value);
}
